import { BUILD_VERSION } from '@digilize/build-version';
import { EnvConfig } from '@digilize/shared/definitions/src';

// Deployable builds stamp a version (see tools/build-version), so a deploy fetches its translations afresh.
export const getTranslationSuffix = (envConfig: EnvConfig) => {
  return !envConfig.development && BUILD_VERSION ? `.json?v=${BUILD_VERSION}` : '.json';
};
